import React from 'react';

import LazyImage from '@components/lazyImage/lazyImage.tsx';
import Switch from '@components/switch/Switch.tsx';
import getFormatedDate from '@functions/getFormatedDate.ts';
import shortText from '@functions/shortText.ts';
import { deleteCursorSupport, setCursorSupport } from '@functions/supportHandler.ts';
import ReferralT from '@global/models/Referral.ts';
import setReferralStatus from '@requests/setReferralStatus.ts';

import { RenderColsT } from '../../types.ts';

const renderReferrals: RenderColsT<'referrals'> = function ({ name: colName, item }) {
    const { loadings } = this.state;

    let content;
    let className;
    const referral = item as ReferralT;

    if (colName === 'logo') {
        const { otherData } = this.props;

        className = '_full _fullH _withContent';

        const setStatus = otherData?.setStatus as typeof setReferralStatus;
        const isActive = referral.status !== 'closed';
        const supportId = `disabled-${referral._id}`;
        const supportProps = setCursorSupport(
            {
                _id: supportId,
                content: isActive ? 'Завершить акцию' : 'Возобновить акцию',
                dir: 'bottom',
            },
            { targetClassName: '.v2table__switch', className: '' },
        );

        content = (
            <>
                {referral.status !== 'completed' && (
                    <div
                        className="v2table__switch _abs"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        {...supportProps}
                    >
                        <Switch
                            className="_mediumSize _green"
                            value={isActive}
                            name="isActive"
                            disabled={!!loadings[referral._id]}
                            onChange={async () => {
                                await this.loadingHandler({ name: referral._id, loading: true });

                                try {
                                    await setStatus({
                                        id: referral._id,
                                        status: referral.status === 'active' ? 'closed' : 'active',
                                    });
                                } catch (error) {}

                                deleteCursorSupport({ id: supportId });

                                await this.loadingHandler({
                                    name: referral._id,
                                    loading: undefined,
                                });
                            }}
                        />
                    </div>
                )}
                {referral.logo?.fullSrc && (
                    <div className="v2table__image _article _abs">
                        <LazyImage src={referral.logo.fullSrc} cover={true} />
                    </div>
                )}
            </>
        );
    }

    if (colName === 'title') {
        content = (
            <>
                <div className="v2table__text">{referral.title}</div>
                <div className="v2table__text _grey _block _top">
                    {shortText({ str: referral.descr, stop: 100 })}
                </div>
            </>
        );
    }

    if (colName === 'type') {
        content = <div className="v2table__text">{referral.typeText}</div>;
    }

    if (colName === 'dates') {
        content = (
            <div className="v2table__text">
                С{' '}
                {getFormatedDate({
                    date: new Date(referral.sDate),
                    isShortYear: true,
                })}
                <br />
                по{' '}
                {getFormatedDate({
                    date: new Date(referral.eDate),
                    isShortYear: true,
                })}
            </div>
        );
    }

    if (colName === 'status') {
        let statusClassName;

        if (referral.status === 'active') {
            statusClassName = '_active';
        }

        if (referral.status === 'closed') {
            statusClassName = '_wait';
        }

        content = (
            <div className={`v2table__status _block ${statusClassName}`}>{referral.statusText}</div>
        );
    }

    return { content, className };
};

export default renderReferrals;
